export enum MedicationFormEnum {
  TABLET = "tablet",
  LIQUID = "liquid",
  CAPSULE = "capsule",
  DROP = "drop",
  PACKET = "packet",
  PATCH = "patch",
  SUPPOSITORY = "suppository",
  INJECTION = "injection",
  UNSPECIFIED = "unspecified",
  OTHER = "other",
}

export const MedicationFormDropdownOptions = [
  { value: MedicationFormEnum.TABLET, label: "Tablet" },
  { value: MedicationFormEnum.LIQUID, label: "Liquid" },
  { value: MedicationFormEnum.CAPSULE, label: "Capsule" },
  { value: MedicationFormEnum.DROP, label: "Drop" },
  { value: MedicationFormEnum.PACKET, label: "Packet" },
  { value: MedicationFormEnum.PATCH, label: "Patch" },
  { value: MedicationFormEnum.SUPPOSITORY, label: "Suppository" },
  { value: MedicationFormEnum.INJECTION, label: "Injection" },
  { value: MedicationFormEnum.UNSPECIFIED, label: "Unspecified" },
  { value: MedicationFormEnum.OTHER, label: "Other" },
];
